<div class="page-loading-shade" *ngIf="isProcessing">
  <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
</div>

<div class="in-form-container" *ngIf="!raiseIncidentData">

  <div class="position-relative grid-content" style="margin-top: 10px;" *ngIf="message.showIncidentSwitch">
    <div>
      <div class="d-flex justify-content-between">
        <div class="d-flex align-items-center px-3">
          <div class="dropdown">
          </div>
        </div>
        <div class="d-flex gap-3">
          <ng-container *ngIf="visibleIncidentGrid; else grid">
            <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center" (click)="switchView()"
              (keydown.enter)="switchView()">
              <img src="../../../assets/img/cr_module/add_new.svg" width="18px" height="18px" alt="add new" />
              <span class="reload_text text-white">Raise Incident</span>
            </div>
          </ng-container>
          <ng-template #grid>
            <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center" (click)="switchView()"
              (keydown.enter)="switchView()">
              <img src="../../../assets/img/cr_module/grid.svg" width="18px" height="18px" alt="add new" />
              <span class="reload_text text-white">My Incident(s)</span>
            </div>
          </ng-template>
        </div>
      </div>
    </div>
  </div>

  <div [hidden]="visibleIncidentGrid">
    <div class="row" *ngIf="dynamicLabel">
      <div class="col-md-3">
        <div>
          <!-- Incident Group -->
          <label id="group-validation" for="email">Incident Group</label>
          <span class="mandatory-symbol">*</span>
        </div>
        <mat-select matInput placeholder="Select" [(ngModel)]="selectedIncidentGroup" (closed)="groupSearchText=''"
          (click)="focusSearch('focus-group-search')" (keydown.enter)="focusSearch('focus-group-search')">
          <input type="search" id="focus-group-search" class="dropdownsearchstyle" [(ngModel)]="groupSearchText"
            matInput placeholder="search">
          <mat-option [value]="null" class="unselectStyle" (onSelectionChange)="onGroupSelect($event,null);"
            [disabled]="freezeIncidentGroupDropDown">Un-select</mat-option>
          <mat-option *ngFor="let item of incidentGroupDropdown | assessmentSearch : groupSearchText"
            (onSelectionChange)="onGroupSelect($event,item);" [value]="item.valueExp"
            [disabled]="freezeIncidentGroupDropDown">
            {{ item.displayExp }}
          </mat-option>
        </mat-select>
      </div>
      <div class="col-md-3">
        <div>
          <!-- Incident Type -->
          <label id="inType-validation" for="in-type"> {{dynamicLabel['IN_TYPE'].fieldName}} </label>
          <span class="mandatory-symbol">*</span>
          <span class="info-icon" *ngIf="dynamicLabel['IN_TYPE'].fieldNotes"
            [matTooltip]="dynamicLabel['IN_TYPE'].fieldNotes">
            <img [src]="infoIconSrc" alt="note" width="18" height="18">
          </span>
        </div>
        <mat-select matInput placeholder="Select" [(ngModel)]="incidentData.inType" (closed)="typeSearchText=''"
          (click)="focusSearch('focus-type-search')" (keydown.enter)="focusSearch('focus-type-search')">
          <input type="search" id="focus-type-search" class="dropdownsearchstyle" [(ngModel)]="groupSearchText" matInput
            placeholder="search">
          <mat-option [value]="null" class="unselectStyle"
            (onSelectionChange)="onIncidentTypeSelect($event,null);">Un-select</mat-option>
          <mat-option *ngFor="let item of incidentTypeDropdown | assessmentSearch : typeSearchText"
            (onSelectionChange)="onIncidentTypeSelect($event,item)" [value]="item.valueExp">
            {{ item.displayExp }}
          </mat-option>
        </mat-select>
      </div>
      <div class="col-md-3" [hidden]="dynamicLabel['DEPT_NAME'].isRemovable == 'Y'">
        <div>
          <!-- Department -->
          <label id="department-validation" for="department">{{dynamicLabel['DEPT_NAME'].fieldName}}</label>
          <span class="mandatory-symbol">*</span>
          <span class="info-icon" *ngIf="dynamicLabel['DEPT_NAME'].fieldNotes"
            [matTooltip]="dynamicLabel['DEPT_NAME'].fieldNotes">
            <img [src]="infoIconSrc" alt="note" width="18" height="18">
          </span>
        </div>
        <mat-select matInput placeholder="Select" [(ngModel)]="incidentData.deptCode" (closed)="departmentSearchText=''"
          (click)="focusSearch('focus-department-search')" (keydown.enter)="focusSearch('focus-department-search')">
          <input type="search" id="focus-department-search" class="dropdownsearchstyle"
            [(ngModel)]="departmentSearchText" matInput placeholder="search">
          <mat-option [value]="null" class="unselectStyle"
            (onSelectionChange)="onDepartmentSelect($event,null);">Un-select</mat-option>
          <mat-option *ngFor="let item of departmentCodeDropdown | assessmentSearch : departmentSearchText"
            (onSelectionChange)="onDepartmentSelect($event,item)" [value]="item.valueExp">
            {{ item.displayExp }}
          </mat-option>
        </mat-select>
      </div>
      <div class="col-md-3">
        <div>
          <!-- Requested At -->
          <label id="requestedAt-validation" for="requested-at">
            {{dynamicLabel['REQUESTED_AT'].fieldName}}
          </label> <span class="mandatory-symbol">*</span>
          <span class="info-icon" *ngIf="dynamicLabel['REQUESTED_AT'].fieldNotes"
            [matTooltip]="dynamicLabel['REQUESTED_AT'].fieldNotes">
            <img [src]="infoIconSrc" alt="note" width="18" height="18">
          </span>
        </div>
        <mat-select matInput placeholder="Select" [(ngModel)]="incidentData.requestedAt"
          (closed)="requestedSearchText=''" (click)="focusSearch('focus-requested-search')"
          (keydown.enter)="focusSearch('focus-requested-search')">
          <input type="search" id="focus-requested-search" class="dropdownsearchstyle" [(ngModel)]="requestedSearchText"
            matInput placeholder="search">
          <mat-option [value]="null" class="unselectStyle"
            (onSelectionChange)="onRequestedAtSelect($event,null);">Un-select</mat-option>
          <mat-option *ngFor="let item of requestedAtDropdown | assessmentSearch : requestedSearchText"
            (onSelectionChange)="onRequestedAtSelect($event,item)" [value]="item.valueExp">
            {{ item.displayExp }}
          </mat-option>
        </mat-select>
      </div>
      <div class="col-md-6" *ngIf="incidentData.requestedAt">
        <div>
          <label id="business-area-validation" for="business-area">
            {{((this.businessAreaName ?? '' )+ ' ' + dynamicLabel['CORE_BUSINESS_AREA_NAME'].fieldName)}}
          </label>
          <span class="mandatory-symbol">*</span>
        </div>
        <mat-select matInput multiple placeholder="Select" #businessArea *ngIf="!isBusinessAreaEmpty"
          [ngStyle]="incidentData.requestedAt ? {'cursor' : 'pointer'} : {'cursor' : 'not-allowed'}"
          [(ngModel)]="incidentData.coreBusinessAreaName" (closed)="coreBusinessSearchText=''"
          [matTooltip]="incidentData.coreBusinessAreaName" (click)="focusSearch('focus-b-area-search')"
          (keydown.enter)="focusSearch('focus-b-area-search')" [disabled]="!incidentData.requestedAt">
          <input type="search" id="focus-b-area-search" class="dropdownsearchstyle" [(ngModel)]="coreBusinessSearchText"
            matInput placeholder="search">
          <div class="select-all">
            <mat-checkbox [(ngModel)]="isAllBusinessAreaSelected" (change)="toggleAllSelection('businessArea')">Select
              All</mat-checkbox>
          </div>
          <mat-option
            *ngFor="let item1 of coreBusinessAreaNameDropdown| multiAssessmentSearchPipe :coreBusinessSearchText"
            [value]="item1.valueExp" (onSelectionChange)="onCoreBusinessAreaNameSelect($event,item1)">
            {{ item1.displayExp }}
          </mat-option>
        </mat-select>
        <textarea type="text" class="input-filed-textarea" rows="4" cols="50" *ngIf="isBusinessAreaEmpty"
          [(ngModel)]="incidentData.coreBusinessAreaName" (input)="limitCharacters($event, 'REQUESTED_AT')"
          (ngModelChange)="onNgModuleChange($event,'business-area-validation')"></textarea>
      </div>
      <div class="col-md-3">
        <div>
          <!-- Reference -->
          <label id="reference-validation" for="reference">{{dynamicLabel['REFERENCE'].fieldName}}</label>
          <span class="mandatory-symbol">*</span>
          <span class="info-icon" *ngIf="dynamicLabel['REFERENCE'].fieldNotes"
            [matTooltip]="dynamicLabel['REFERENCE'].fieldNotes">
            <img [src]="infoIconSrc" alt="note" width="18" height="18">
          </span>
        </div>
        <mat-select matInput placeholder="Select" [(ngModel)]="incidentData.reference" (closed)="referenceSearchText=''"
          (click)="focusSearch('focus-reference-search')" (keydown.enter)="focusSearch('focus-reference-search')">
          <input type="search" id="focus-reference-search" class="dropdownsearchstyle" [(ngModel)]="referenceSearchText"
            matInput placeholder="search">
          <mat-option [value]="null" class="unselectStyle"
            (onSelectionChange)="onReferenceSelect($event,null);">Un-select</mat-option>
          <mat-option *ngFor="let item of incidentReferenceDropdown | assessmentSearch : referenceSearchText"
            (onSelectionChange)="onReferenceSelect($event,item)" [value]="item.valueExp">
            {{ item.displayExp }}
          </mat-option>
        </mat-select>
      </div>
      <div class="col-md-6" *ngIf="visibleReferenceIfOthers">
        <div>
          <!-- Reference if Others -->
          <label id="reference-others-validation" for="reference-others">Reference if Others</label>
          <span class="mandatory-symbol">*</span>
        </div>
        <textarea id="referenceOthers" type="text" class="input-filed-textarea" style="margin-top: 8px;" rows="4"
          cols="50" [(ngModel)]="incidentData.referenceOthers"
          (ngModelChange)="onNgModuleChange($event,'reference-others-validation')"></textarea>
      </div>
      <div class="col-md-3">
        <div>
          <!-- Identified On -->
          <label id="identifiedOn-validation" for="identified-on">
            {{dynamicLabel['IDENTIFIED_ON'].fieldName}}
          </label> <span class="mandatory-symbol">*</span>
          <span class="info-icon" *ngIf="dynamicLabel['IDENTIFIED_ON'].fieldNotes"
            [matTooltip]="dynamicLabel['IDENTIFIED_ON'].fieldNotes">
            <img [src]="infoIconSrc" alt="note" width="18" height="18">
          </span>
        </div>
        <input type="text" class="form-control data-picker-continer" bsDatepicker [bsConfig]="identifiedOnConfig"
          [dateCustomClasses]="dateCustomClasses" [(ngModel)]="incidentData.identifiedOn"
          (ngModelChange)="onNgModuleChange($event,'identifiedOn-validation')">
      </div>
      <div class="col-md-3" [hidden]="dynamicLabel['EXPECTED_TO_BE_STARTED_ON'].isRemovable == 'Y'">
        <div>
          <!-- Expected to be Started On -->
          <label id="expectedToBeStartedOn-validation" for="expected-to-be-started-on">
            {{dynamicLabel['EXPECTED_TO_BE_STARTED_ON'].fieldName}}
          </label> <span class="mandatory-symbol">*</span>
          <span class="info-icon" *ngIf="dynamicLabel['EXPECTED_TO_BE_STARTED_ON'].fieldNotes"
            [matTooltip]="dynamicLabel['EXPECTED_TO_BE_STARTED_ON'].fieldNotes">
            <img [src]="infoIconSrc" alt="note" width="18" height="18">
          </span>
        </div>
        <input type="text" class="form-control data-picker-continer" bsDatepicker
          [bsConfig]="expectedToBeStartedOnConfig" [dateCustomClasses]="dateCustomClasses"
          [(ngModel)]="incidentData.expectedToBeStartedOn"
          (ngModelChange)="onNgModuleChange($event,'expectedToBeStartedOn-validation'); onExpectedToBeStartedOnChange()">
      </div>
      <div class="col-md-3">
        <div>
          <!-- Expected Closure Date -->
          <label id="expcetedClosureOn-validation" for="expected-closure-on">
            {{dynamicLabel['EXPCETED_CLOSURE_ON'].fieldName}}
          </label> <span class="mandatory-symbol">*</span>
          <span class="info-icon" *ngIf="dynamicLabel['EXPCETED_CLOSURE_ON'].fieldNotes"
            [matTooltip]="dynamicLabel['EXPCETED_CLOSURE_ON'].fieldNotes">
            <img [src]="infoIconSrc" alt="note" width="18" height="18">
          </span>
        </div>
        <input type="text" class="form-control data-picker-continer" bsDatepicker
          [bsConfig]="generateExpectedClosureDateConfig()" [dateCustomClasses]="dateCustomClasses"
          [(ngModel)]="incidentData.expcetedClosureOn"
          (ngModelChange)="onNgModuleChange($event,'expcetedClosureOn-validation')">
      </div>
      <div class="col-md-3">
        <div>
          <!-- Initiated On Behalf of Others? -->
          <label for="email">Initiated On Behalf of Others?</label>
        </div>
        <mat-slide-toggle color="primary" name="initiatedOnBehalfBy"
          [(ngModel)]="incidentData.initiatedOnBehalfByOthers">
          <ng-container *ngIf="incidentData.initiatedOnBehalfByOthers; else no">
            <span class="active-inActive-container" style="color: rgb(43, 227, 43);">Yes</span>
          </ng-container>
          <ng-template #no>
            <span style="color: red;">No</span>
          </ng-template>
        </mat-slide-toggle>
      </div>
      <div class="col-md-3" *ngIf="incidentData.initiatedOnBehalfByOthers">
        <div>
          <!-- Is Outside Organization? -->
          <label for="out-org">{{dynamicLabel['IS_OUTSIDE_ORGANIZATION'].fieldName}}</label>
          <span class="info-icon" *ngIf="dynamicLabel['IS_OUTSIDE_ORGANIZATION'].fieldNotes"
            [matTooltip]="dynamicLabel['IS_OUTSIDE_ORGANIZATION'].fieldNotes">
            <img [src]="infoIconSrc" alt="note" width="18" height="18">
          </span>
        </div>
        <mat-slide-toggle color="primary" name="isOutsideOrganization" [(ngModel)]="incidentData.isOutsideOrganization"
          (change)="onIsOutsideOrganizationChange($event)">
          <ng-container *ngIf="incidentData.isOutsideOrganization; else no">
            <span class="active-inActive-container" style="color: rgb(43, 227, 43);">Yes</span>
          </ng-container>
          <ng-template #no>
            <span style="color: red;">No</span>
          </ng-template>
        </mat-slide-toggle>
      </div>
      <div class="col-md-3" *ngIf="incidentData.initiatedOnBehalfByOthers">
        <div>
          <!-- Initiated On Behalf -->
          <label id="initiatedon-behalf-validation" for="behalf-of-others">
            {{dynamicLabel['INITIATED_ON_BEHALF_BY'].fieldName}}
          </label> <span class="mandatory-symbol">*</span>
          <span class="info-icon" *ngIf="dynamicLabel['INITIATED_ON_BEHALF_BY'].fieldNotes"
            [matTooltip]="dynamicLabel['INITIATED_ON_BEHALF_BY'].fieldNotes">
            <img [src]="infoIconSrc" alt="note" width="18" height="18">
          </span>
        </div>
        <mat-select matInput placeholder="Select" [(ngModel)]="incidentData.initiatedOnBehalf"
          (closed)="behalfOfSearchText=''" (click)="focusSearch('focus-behalf-of-search')"
          (keydown.enter)="focusSearch('focus-behalf-of-search')">
          <input type="search" id="focus-behalf-of-search" class="dropdownsearchstyle" [(ngModel)]="behalfOfSearchText"
            matInput placeholder="search">
          <mat-option [value]="null" class="unselectStyle"
            (onSelectionChange)="onInitiatedOnBehalfSelect($event,null);">Un-select</mat-option>
          <mat-option *ngFor="let item of initiatedOnBehalfDropDown | assessmentSearch : behalfOfSearchText"
            (onSelectionChange)="onInitiatedOnBehalfSelect($event,item)" [value]="item.valueExp">
            {{ item.displayExp }}
          </mat-option>
        </mat-select>
      </div>
      <div class="col-md-3">
        <div>
          <!-- Impact Type -->
          <label id="impact-type-validation" for="impact-type">
            {{dynamicLabel['IMPACT_TYPE'].fieldName}}
          </label> <span class="mandatory-symbol">*</span>
          <span class="info-icon" *ngIf="dynamicLabel['IMPACT_TYPE'].fieldNotes"
            [matTooltip]="dynamicLabel['IMPACT_TYPE'].fieldNotes">
            <img [src]="infoIconSrc" alt="note" width="18" height="18">
          </span>
        </div>
        <mat-select matInput placeholder="Select" [(ngModel)]="incidentData.impactType"
          (closed)="impactTypeSearchText=''" (click)="focusSearch('impact-type-search')"
          (keydown.enter)="focusSearch('impact-type-search')">
          <input type="search" id="impact-type-search" class="dropdownsearchstyle" [(ngModel)]="impactTypeSearchText"
            matInput placeholder="search">
          <mat-option [value]="null" class="unselectStyle"
            (onSelectionChange)="onImpactTypeSelect($event,null);">Un-select</mat-option>
          <mat-option *ngFor="let item of impactTypeDropdown | assessmentSearch : impactTypeSearchText"
            (onSelectionChange)="onImpactTypeSelect($event,item)" [value]="item.valueExp">
            {{ item.displayExp }}
          </mat-option>
        </mat-select>
      </div>
      <div class="col-md-6">
        <div>
          <!-- Impact Description -->
          <label id="impact-description-validation" for="impact-description">
            {{dynamicLabel['IMPACT_DESCRIPTION'].fieldName}}
          </label> <span class="mandatory-symbol">*</span>
          <span class="info-icon" *ngIf="dynamicLabel['IMPACT_DESCRIPTION'].fieldNotes"
            [matTooltip]="dynamicLabel['IMPACT_DESCRIPTION'].fieldNotes">
            <img [src]="infoIconSrc" alt="note" width="18" height="18">
          </span>
        </div>
        <div class="row">
          <div class="hideToolbar col-sm-11">
            <st-editor [(ngModel)]="incidentData.impactDescription" [config]="config" [spellcheck]="true"
              (ngModelChange)="onNgModuleChange($event,'impact-description-validation')"
              (paste)="onPaste($event)"></st-editor>
          </div>
          <div class="col-sm-1 angular-editor-edit"><i class="far fa-edit" (click)="openEditor('Impact Description')"
              (keydown.enter)="openEditor('Impact Description')"></i>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div>
          <!-- Short Description -->
          <label id="shortDescription-validation" for="short-description">
            {{dynamicLabel['SHORT_DESCRIPTION'].fieldName}}
          </label> <span class="mandatory-symbol">*</span>
          <span class="info-icon" *ngIf="dynamicLabel['SHORT_DESCRIPTION'].fieldNotes"
            [matTooltip]="dynamicLabel['SHORT_DESCRIPTION'].fieldNotes">
            <img [src]="infoIconSrc" alt="note" width="18" height="18">
          </span>
        </div>
        <input id="shortDescription" class="input-filed-continers" type="text" maxlength="400" autocomplete="off"
          [(ngModel)]="incidentData.shortDescription"
          (ngModelChange)="onNgModuleChange($event,'shortDescription-validation')">
      </div>
      <div class="col-md-6">
        <div>
          <!-- Description -->
          <label id="description-validation" for="description">
            {{dynamicLabel['DESCRIPTION'].fieldName}}
          </label> <span class="mandatory-symbol">*</span>
          <span class="info-icon" *ngIf="dynamicLabel['DESCRIPTION'].fieldNotes"
            [matTooltip]="dynamicLabel['DESCRIPTION'].fieldNotes">
            <img [src]="infoIconSrc" alt="note" width="18" height="18">
          </span>
        </div>
        <div class="row">
          <div class="hideToolbar col-sm-11">
            <st-editor [(ngModel)]="incidentData.description" [config]="config" [spellcheck]="true"
              (ngModelChange)="onNgModuleChange($event,'description-validation')" (paste)="onPaste($event)"></st-editor>
          </div>
          <div class="col-sm-1 angular-editor-edit">
            <i class="far fa-edit" (click)="openEditor('Description')" (keydown.enter)="openEditor('Description')"></i>
          </div>
        </div>
      </div>
      <div class="col-md-3"
        *ngIf="selectedIncidentGroup && qmsService.selectedGroupDetailData.isRiskCalculationReqd == 'Y'">
        <div>
          <!-- Is Risk Calculation Reqd? -->
          <label for="risk-reqd">{{dynamicLabel['IS_RISK_CALCULATION_REQD'].fieldName}}</label>
          <span class="info-icon" *ngIf="dynamicLabel['IS_RISK_CALCULATION_REQD'].fieldNotes"
            [matTooltip]="dynamicLabel['IS_RISK_CALCULATION_REQD'].fieldNotes">
            <img [src]="infoIconSrc" alt="note" width="18" height="18">
          </span>
        </div>
        <mat-slide-toggle color="primary" [(ngModel)]="incidentData.isRiskCalculationReqd">
          <ng-container *ngIf="incidentData.isRiskCalculationReqd; else no">
            <span class="active-inActive-container" style="color: rgb(43, 227, 43);">Yes</span>
          </ng-container>
          <ng-template #no>
            <span style="color: red;">No</span>
          </ng-template>
        </mat-slide-toggle>
      </div>
      <div class="col-md-3 field-row" *ngIf="qmsService.selectedGroupDetailData.effectivenessCheckEnabled=='Y'">
        <!-- Is Effectiveness Check Mandatory? -->
        <div><label for="email">{{dynamicLabel['EFFECTIVENESS_CHECK_REQD'].fieldName}}</label></div>
        <mat-slide-toggle color="primary" [(ngModel)]="incidentData.effectivenessCheckReqd">
          <ng-container *ngIf="incidentData.effectivenessCheckReqd; else no">
            <span class="active-inActive-container" style="color: rgb(43, 227, 43);">Yes</span>
          </ng-container>
          <ng-template #no>
            <span style="color: red;">No</span>
          </ng-template>
        </mat-slide-toggle>
      </div>
      <div class="form-template ActivityPage" id="Additionaldetail" *ngIf="!message.showIncidentSwitch">
        <app-flexible-fields #flexible [from]="'Master'"></app-flexible-fields>
      </div>
    </div>
    <br>
    <div class="row" style="position:sticky; bottom:0; z-index: 2; background-color: white;">
      <div class="button-continer btn-align" mat-dialog-actions>
        <button mat-stroked-button class="addButton" (click)="save(incidentData)">
          <i class="fas fa-check"></i> Raise Incident
        </button>
        <button *ngIf="!message.showIncidentSwitch" mat-stroked-button class="cancelButton" (click)="cancel()">
          <i class="fa fa-close"></i> Cancel
        </button>
      </div>
    </div>
  </div>

  <div [hidden]="!visibleIncidentGrid">
    <div class="position-relative grid-content">
      <div>
        <div class="d-flex justify-content-between">
          <div class="d-flex align-items-center px-3">
            <div class="dropdown">
            </div>
          </div>
          <div class="d-flex gap-3">
            <div id="header-container">
              <div class="">
                <div class="search-container">
                  <span class="fa fa-search form-control-feedback"></span>
                  <input type="text" class="form-control search_input" style="font-size: 12px"
                    placeholder="Search here..." [(ngModel)]="searchValue" (input)="applyFilter2($event)" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="table-container">
        <table class="dynamic-table-container" aria-describedby="table-description">
          <th style="min-width: 60px; text-align: center;"
            [class]="makeStickyColumns != -1 ? 'sticky-checkbox-col checkbox-col' : '' ">
            <div style="display: flex;">
              <div>
                <i id="parent-menu-icons" class="fa-solid fa-ellipsis-vertical"></i>
              </div>
            </div>
          </th>
          <th id="grid-header-container" (focus)="focusEmpty()"
            *ngFor="let columnData of columnLists.fieldColumnarray; let ix = index;" [ngStyle]="{'min-width': columnData.width,'max-width': columnData.width,'overflow': 'hidden',
                'text-overflow': 'ellipsis',
                'white-space': 'nowrap'}" class="sticky-dynamic-col1" (mouseover)="cssFunction(0)">
            <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-2">
              <span>{{ columnData.fieldColumnarray }}</span>
              <div class="d-flex gap-2 align-items-center">
                <div class="sort" (click)="sortColumn(columnLists.columnsListarray[ix],columnData)"
                  (keydown.enter)="sortColumn(columnLists.columnsListarray[ix],columnData)">
                  <div><i *ngIf="sortedDisplayColumn==columnData.fieldColumnarray && sortDirection=='asc'"
                      class='fas fa-angle-up' style='font-size:11px'></i></div>
                  <div><i *ngIf="sortedDisplayColumn==columnData.fieldColumnarray && sortDirection=='desc'"
                      class='fas fa-angle-down' style='font-size:11px'></i></div>
                  <img *ngIf="sortedDisplayColumn!=columnData.fieldColumnarray"
                    src="../../../assets/img/qms_img/sort.svg" width="9px" height="16px" alt="sort" />
                </div>
              </div>
            </div>
          </th>
          <th id="menu" class="sticky-col first-col"></th>
          <tr>
            <td [class]="  makeStickyColumns != -1 ? 'sticky-checkbox-col checkbox-col' : '' "></td>
            <td *ngFor=" let columnData of columnLists.fieldColumnarray; let ix = index " (focus)="focusEmpty()"
              [ngStyle]="{ 'min-width': columnData.width != null ? columnData.width : '200px' }"
              class="sticky-dynamic-col1" (mouseover)="cssFunction(0)">
              <div class="row-search-container"><input type="text" class="form-control" placeholder="Search"
                  (input)="applyFilter3(columnLists.columnsListarray[ix], $event)" /> </div>
            </td>
          </tr>
          <tr *ngFor="let list of pagedItems let idx = index;">
            <td style="min-width: 60px; text-align: center;"
              [class]="makeStickyColumns != -1 ? 'sticky-checkbox-col checkbox-col' : '' ">
              <div style="display: flex;">
                <div [ngClass]="list.childCheckBox ?'static_icon':'hover-menu-icons'">
                  <i class="fa-solid fa-ellipsis-vertical"></i>
                </div>
                <div>
                  <input type="checkbox" style="zoom: 1.2;" [checked]="list.childCheckBox"
                    (change)="onChildChanged($event, list, idx)">
                </div>
              </div>
            </td>
            <td id="grid-row-container" *ngFor="let key of columnLists.columnsListarray1; let i = index;"
              (focus)="focusEmpty()" class="sticky-dynamic-row1" [ngStyle]="{'min-width': key.width[i],'max-width': key.width[i],'overflow': 'hidden',
                    'text-overflow': 'ellipsis',
                    'white-space': 'nowrap'}" (mouseover)="cssFunction(i)"
              (keydown.enter)="detailsData($event, list, i, false)" (click)="detailsData($event, list, i, false)">
              <span *ngIf="key.dataType=='CHECKBOX'">
                <div class="gridCheckBoxes">
                  <img *ngIf="list[key.columnsListarray]" src="../../assets/img/accessSymbol.svg" alt="Yes" width="20"
                    height="20">
                  <img *ngIf="list[key.columnsListarray]==false" src="../../assets/img/noAcessSymbol.svg" alt="No"
                    width="20" height="20">
                </div>
              </span>

              <span *ngIf="list[key.columnsListarray]=='htmlClobView' || list[key.columnsListarray]=='htmlClobView'">
                <div class="download-button-continer btn-align" mat-dialog-actions>
                  <button class="d-flex align-items-center" mat-stroked-button class="downloadButton"
                    (click)="getClobData(list,key.columnsListarray)">
                    <img src="../../../assets/img/cr_module/download.svg" width="12px" height="12px" alt="download">
                    <span class="ms-1">View</span>
                  </button>
                </div>
              </span>
              <span
                *ngIf="key.dataType!='CHECKBOX' && key.dataType!='DATE' && list[key.columnsListarray] != 'htmlClobView' && list[key.columnsListarray] != 'fileIspresentsa' && list[key.columnsListarray] !='fileIsNotpresentsa'">
                {{ list[key.columnsListarray] }}
              </span>
              <span *ngIf="key.dataType=='DATE'">{{ list[key.columnsListarray] }}</span>
            </td>
          </tr>
        </table>
        <div class="d-flex justify-content-center">
          <div class="width-cheat small paginationCell">
            <div class="d-flex align-items-center gap-3">
              <div class="pagination_text mt-3">
                {{ showingRowsText }}
                1-{{ perPage }} of {{ collectionSize | number }}
              </div>
              <div>
                <ngb-pagination class="leftpadding" (pageChange)="setPage(pager.currentPage, $event)" [disabled]="false"
                  [collectionSize]="pager.totalItems" [(page)]="pager.currentPage" [maxSize]="maxSize" [rotate]="true"
                  [pageSize]="perPage" [ellipses]="false" [boundaryLinks]="true" size="sm">
                </ngb-pagination>
              </div>
              <div ngbDropdown class="mt-3">
                <button class="btn btn-primary btn-sm mr-1 bg-white pagination_text" id="dropdownBasic1"
                  ngbDropdownToggle>
                  {{ perPage }}
                  <i class="ms-1 fa-solid fa-chevron-down"></i>
                </button>
                <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
                  <button ngbDropdownItem (click)="paginationCall(10)">10</button>
                  <button ngbDropdownItem (click)="paginationCall(20)">20</button>
                  <button ngbDropdownItem (click)="paginationCall(50)">50</button>
                </div>
                per page
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #angularEditor>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="cancelAngularEditorData()" mat-button><i
      class="fa popupClose">&#xf00d;</i></button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle"> {{ this.textareaEditorTitle }}</label>
    <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
  </div>
  <div class="row">
    <div class="col-md-12">
      <div class="row"></div>
      <div class="col-sm-12"><st-editor [(ngModel)]="editorValue" [config]="config1" [spellcheck]="true"
          (paste)="onPaste($event)"></st-editor></div>
    </div>
  </div>
  <div class="button-continer btn-align" mat-dialog-actions style="margin-top: 10px;">
    <button mat-stroked-button class="addButton" style="margin-right: 5px;" (click)="okAngularEditorData(editorValue)">
      <i class="fas fa-check"></i> Save
    </button>
    <button mat-stroked-button class="cancelButton" (click)="cancelAngularEditorData()">
      <i class="fa fa-close"></i> Cancel
    </button>
  </div>
</ng-template>

<ng-template #mandatoryPopup>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>

  <button class="close close-button" (click)="closeMandatoryPopup()" mat-button>
    <i class="fa popupClose">&#xf00d;</i>
  </button>

  <div mat-dialog-title>
    <label for="title" class="popupTitle"> Mandatory Alert </label>
  </div>

  <div style="margin: 15px 15px;">
    <div style="display: flex; justify-content: center; align-items: center;">
      <span style="font-weight: 500; font-size: larger;"> Please enter all Mandatory Fields
        <span style="color: red; font-size: x-large;"><i class="fa-solid fa-exclamation"></i></span>
      </span>
    </div>
    <div class="button-continer btn-align" mat-dialog-actions>
      <button mat-stroked-button class="cancelButton" (click)="closeMandatoryPopup()">
        Ok
      </button>
    </div>
  </div>
</ng-template>

<app-editor #clobViewPopup></app-editor>
